"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const LOCAL_STORAGE_CHANGE_EVENT = "gv:onLocalStorageChange";
exports.LOCAL_STORAGE_CHANGE_EVENT = LOCAL_STORAGE_CHANGE_EVENT;
//# sourceMappingURL=events.js.map
